export default __webpack_public_path__ + "static/media/food.3f48dfb9.jpg";